export default "__VITE_ASSET__BkztMXm$__"